// ACS brand values for the few places that need a literal colour in TS (vendor props, SVG attributes of our own charts).
// Same values as the CSS tokens of copycat.css (.cc-acs layer), sourced from the ACS public runtime / executable pack
// (repo-ubm-foundry/brands/acs, see FIN-HOME-ACS): cream, ink, gold (action), deep gold (link, focus, AA on cream), khaki
// (documentary patrimony, third ring only). Charts and rings use the 3 discriminating tones gold / ink / khaki.
export const ACS = {
  cream: "#f6f4ef", sunk: "#efece4", rule: "#e4ded2",
  ink: "#101013", inkStrong: "#0b0b0d", muted: "#605f5e",
  gold: "#c0a46d", goldDeep: "#8a6a1f", goldHover: "#dcc89a", khaki: "#6e6a3b",
} as const;
/** Ring / chart tones by position: stroke (graphic) and legend text (AA on cream). */
export const axisTone = (i: number) => `var(--acs-axis-${(i % 3) + 1})`;
export const axisText = (i: number) => `var(--acs-axis-${(i % 3) + 1}-text)`;
